import React from 'react';
import { Card, Form, InputNumber, Tooltip, Typography } from '@duxton-web/ui';
import { useParams } from 'react-router-dom';

import { useExperimentContext } from '../../contexts/experiment-context';
import {
  getAssignmentStrategy,
  isPercentageSplitStrategy,
  isViewMode,
  PopulationTargetMode,
} from '@/features/experiment/constants';

const SampleSize = () => {
  const params = useParams<{ action: string }>();
  const { action } = params;
  const readOnly = isViewMode(action);

  const experimentContext = useExperimentContext();
  const { experiment, configurations } = experimentContext;
  const targetMode = experiment?.byGroup
    ? PopulationTargetMode.STATIC
    : PopulationTargetMode.DYNAMIC;
  const experimentAssignmentStrategy = getAssignmentStrategy(configurations);

  const sampleSizeRequired =
    targetMode === PopulationTargetMode.DYNAMIC &&
    isPercentageSplitStrategy(experimentAssignmentStrategy);

  return (
    <Card styles={{ body: { padding: 16 } }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography.Text strong>
            Select Experiment Sample Size
          </Typography.Text>
          <Typography.Metadata type="secondary">
            Select the sample size of the available population.
          </Typography.Metadata>
        </div>

        <>
          {sampleSizeRequired ? (
            <Form.Item
              name="sampleSize"
              style={{ marginBottom: 0 }}
              rules={[
                {
                  required: sampleSizeRequired,
                  message: 'Please input a sample size',
                },
                () => ({
                  validator(_, value) {
                    if (value > 0 || value === null) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('Sample size must be bigger than 0'),
                    );
                  },
                }),
              ]}
            >
              <InputNumber
                type="number"
                precision={0}
                max={100}
                min={1}
                disabled={readOnly}
                style={{ width: 150 }}
                suffix="%"
              />
            </Form.Item>
          ) : (
            <Tooltip
              title={
                experimentAssignmentStrategy
                  ? 'Sample size not supported for time slice, geo slice, explicit group strategies and static population'
                  : ''
              }
            >
              <InputNumber
                value={experiment?.sampleSize}
                type="number"
                max={100}
                min={0}
                disabled={!sampleSizeRequired}
                style={{ width: 150 }}
                prefix="%"
              />
            </Tooltip>
          )}
        </>
      </div>
    </Card>
  );
};

export default SampleSize;
